import { Component, QueryList, ViewChildren, OnInit, ViewChild, inject, AfterViewInit  } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, UntypedFormControl, Validators, FormBuilder, FormArray } from '@angular/forms';


import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { id } from 'date-fns/locale';
import { MatStepperModule } from '@angular/material/stepper';
import { RequestsService } from '../requests.service';
import { selfcreditService } from '../../self-credit/self-credit.service';

@Component({
  selector: 'app-approve-request',
  templateUrl: './approve-request.component.html',
  styleUrls: ['./approve-request.component.scss']
})
export class ApproveRequestComponent {


id;

constructor(
  private modalService: BsModalService, 
  private router: Router, 
  public service: selfcreditService,
  private formBuilder: UntypedFormBuilder,
  private route: ActivatedRoute) {
}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
      
  this.service.AcceptCredit(this.id).subscribe((reps:any) =>{
      Swal.fire('',reps.success ? reps.data : reps.error,reps.success ? 'success' : 'error').then(resp2 => {window.location.reload();})
  },error => {
    Swal.fire({
      icon: 'error',
      text: 'No pudimos realizar el registro, intenta nuevamente'
    })      
  })

  }
}
